<template>
  <div>
    <div @click="toggleNotifications" class="notification-ring">
      <em class="far fa-bell color-primary-4 mr-2 font-16" />
      <span class="color-primary-4 font-14">
        {{ $t('Notifications') }}
      </span>
      <b-badge variant="danger" pill>{{ notifications.length }}</b-badge>
    </div>
    <div v-if="showNotifications" class="notification-list">
      <ul v-if="notifications.length > 0" class="list-unstyled">
        <li
          v-for="notification in notifications"
          :key="notification.id"
          class="mb-1 p-2 border-bottom"
        >
          <div class="notification-item">
            <div class="avatar mr-3">
              <i class="far fa-user-circle"></i>
            </div>
            <div class="notification-content">
              <div class="notification-header">
                <strong class="mr-2">{{ notification.user }}</strong>
                <div class="notification-actions justify-end mt-1">
                  <!-- <i @click="markAsRead(notification.id)" class="far fa-check-circle"></i> -->
                </div>
              </div>
              <div class="notification-message">
                {{
                  notification.message.length > 20
                    ? notification.message.slice(0, 20) + '...'
                    : notification.message
                }}
              </div>
              <div class="notification-date">
                {{ notification.date }}
              </div>
            </div>
          </div>
        </li>
      </ul>
      <p v-else>No notifications</p>
    </div>
  </div>
</template>

<script>
import * as signalR from '@microsoft/signalr';
import store, { modulesName } from '@/store';
import roles from '@/utils/constants/roles.js';

export default {
  name: 'Notifications',
  data() {
    return {
      notifications: [],
      showNotifications: false,
    };
  },
  created() {
    if (
      store.getters[`${modulesName.userModuleName}/role`] ===
        roles.SUPERVISOR ||
      store.getters[`${modulesName.userModuleName}/role`] === roles.ADMIN
    ) {
      this.connection = new signalR.HubConnectionBuilder()
        .withUrl(process.env.VUE_APP_URL_API + '/NotificationHub')
        .build();

      this.connection.on('ReceiveNotification', (date, user, message) => {
        this.notifications.push({ date, user, message });
      });
      this.connection.start();
      // .catch((err) => console.error(err));
    }
  },
  methods: {
    toggleNotifications() {
      this.showNotifications = !this.showNotifications;
    },
  },
};
</script>

<style scoped>
.notification-ring {
  cursor: pointer;
}

.notification-list {
  position: absolute;
  background-color: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 10px;
  z-index: 999;
}

.notification-header {
  display: inline-flex;
}

.notification-item {
  display: inline-flex;
  align-items: center;
}

.notification-actions {
  display: inline-flex;
}

.notification-actions i:hover {
  cursor: pointer;
  color: green;
}

.notification-date {
  font-size: 12px;
}

.notification-message {
  font-size: 14px;
}

/* Add hover effect to list items */
.notification-list li:hover {
  background-color: #f5f5f5;
}
</style>
